export function init8Digits () {
  if (window._eightDigitsInitialized) {
    return;
  }
  window._trackingCode = 'rq840ctp';
  (function() {
    var wa = document.createElement('script'); wa.type = 'text/javascript'; wa.async = true;
    wa.src = '//cdn.8digits.com/automation.js';
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(wa, s);
    window._eightDigitsInitialized = true
  })();
}




// WEBPACK FOOTER //
// ./src/vendors/8digits.js